import { SessionListParam } from '@mygpt/types';

/**
 * 找出错误气泡「再生成」时应重发的用户提问。
 * 优先用错误气泡自身记录的 question；没有则从该气泡往前找最近一条非空的用户消息。
 * 找不到返回 undefined，调用方应隐藏按钮，绝不能按位置直接取 messages[index - 1]。
 */
export const findRegenerateQuestion = (messages: SessionListParam[], index: number): string | undefined => {
  const item = messages[index];
  if (item?.question?.trim()) return item.question;

  for (let i = index - 1; i >= 0; i--) {
    const message = messages[i];
    if (message && !message.isAnswer && message.text?.trim()) return message.text;
  }
  return undefined;
};
